module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M27.5 22l-3.3-5.5h6.7zM15.6 10.3l5.4 5.2L10.2 17zm-6.5 6.8l6-7.4-7.4-4-5.9 7.4z"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/assign_roof.svg
// module id = 698
// module chunks = 2